import { render } from "./Photos.vue?vue&type=template&id=4ef89a64&ts=true"
import script from "./Photos.vue?vue&type=script&lang=ts"
export * from "./Photos.vue?vue&type=script&lang=ts"

import "./Photos.vue?vue&type=style&index=0&id=4ef89a64&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\Basseliersstraat\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__